<form [formGroup]="personalDetailsForm" autocomplete="off">
  <!-- <form [formGroup]="personalDetailsForm"  #formRef="ngForm" class="needs-validation"> -->

  <div class="step-container">

    <ng-template #labelFive>{{ getTranslation('personalDetails.title') }} </ng-template>
    <div class="step-title">
      {{ isEditable ? getTranslation('personalDetails.title') : getTranslation('personalDetails.blockedForEdit') }}
      <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
    </div>

    <div *ngIf="isJsonShow">
      <span>{{ personalDetailsForm.value | json }}</span>
    </div>

    <!-- Row 1: Name Fields -->
    <div class="row gx-2">
      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputFirstName" class="form-label">{{ getTranslation('form.firstName') }}: <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="inputFirstName" formControlName="FirstName"
          [placeholder]="getTranslation('placeholder.firstName')" maxlength="50" >
        <div *ngIf="submitted && personalDetailsForm.controls['FirstName'].invalid" class="text-danger">
          {{ getTranslation('validation.firstNameRequired') }}
        </div>
      </div>

      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputMiddleName" class="form-label">{{ getTranslation('form.middleNameVariants') }} : <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="inputMiddleName" formControlName="MiddleName"
          [placeholder]="getTranslation('placeholder.middleName')" maxlength="50" >
        <div *ngIf="submitted && personalDetailsForm.controls['MiddleName'].invalid" class="text-danger">
          {{ getTranslation('validation.middleNameRequired') }}
        </div>
      </div>

      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputLastName" class="form-label">{{ getTranslation('form.lastName') }}: <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="inputLastName" formControlName="LastName"
          [placeholder]="getTranslation('placeholder.lastName')" maxlength="50" >
        <div *ngIf="submitted && personalDetailsForm.controls['LastName'].invalid" class="text-danger">
          {{ getTranslation('validation.lastNameRequired') }}
        </div>
      </div>
    </div>

    <!-- Row 2: Date of Birth, Age, and Marital Status -->
    <div class="row gx-2">
      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputDob" class="form-label">{{ getTranslation('form.dateOfBirth') }}: <span class="text-danger">*</span></label>
        <app-custom-date-picker 
          formControlName="DateOfBirth" 
          [placeholder]="getTranslation('placeholder.dateOfBirth')"
          [maxDate]="maxDate"
          >
        </app-custom-date-picker>
        <div *ngIf="submitted && personalDetailsForm.controls['DateOfBirth'].invalid" class="text-danger">
          {{ getTranslation('validation.dateOfBirthRequired') }}
        </div>
      </div>

      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputAge" class="form-label">{{ getTranslation('form.age') }}</label>
        <input type="text" class="form-control" id="inputAge" 
          [value]="currentAge" [placeholder]="getTranslation('placeholder.ageAuto')" readonly>
      </div>

      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputMaritalStatus" class="form-label">{{ getTranslation('form.maritalStatus') }}: <span class="text-danger">*</span></label>
        <select class="form-control" id="inputMaritalStatus" formControlName="MaritalStatus">
          <option [ngValue]="null" disabled selected>{{ getTranslation('placeholder.selectMaritalStatus') }}</option>
          <option value="Single">{{ getTranslation('options.single') }}</option>
          <option value="Married">{{ getTranslation('options.married') }}</option>
          <!-- <option value="Divorced">Divorced</option> -->
          <!-- <option value="Widowed">Widowed</option> -->
          <option value="Other">{{ getTranslation('options.other') }}</option>
        </select>
        <div *ngIf="submitted && personalDetailsForm.controls['MaritalStatus'].invalid" class="text-danger">
          {{ getTranslation('validation.requiredField') }}
        </div>
      </div>
    </div>

    <!-- Row 3: Before Marriage Name (conditional), Gender, Other Gender (conditional) -->
    <div class="row gx-2">
    

      <div class="form-group col-12 col-md-4 mb-3">
        <label for="GenderCode">{{ getTranslation('form.gender') }}</label>
        <select id="GenderCode" class="form-control" formControlName="GenderCode" >
          <!-- <select id="GenderCode" class="form-control" formControlName="GenderCode" (change)="onGenderCodeChange($event)"> -->
          <option value="">{{ getTranslation('placeholder.selectGender') }}</option>
          <option value="M">{{ getTranslation('options.male') }}</option>
          <option value="F">{{ getTranslation('options.female') }}</option>
          <option value="O">{{ getTranslation('options.other') }}</option>
        </select>
        <div *ngIf="submitted && personalDetailsForm.controls['GenderCode'].invalid" class="text-danger">
          {{ getTranslation('validation.genderRequired') }}
        </div>
      </div>
      
  <div class="form-group col-12 col-md-4 mb-3" *ngIf="personalDetailsForm.get('MaritalStatus')?.value === 'Married' && (personalDetailsForm.get('GenderCode')?.value === 'F' ||
     personalDetailsForm.get('GenderCode')?.value === 'O')">
        <label for="BeforeMarriage">{{ getTranslation('form.beforeMarriageFullName') }}</label>
        <input type="text" id="BeforeMarriageFullName" class="form-control" formControlName="BeforeMarriageFullName"
          [placeholder]="getTranslation('placeholder.beforeMarriageFullName')" maxlength="50" />
        <div *ngIf="submitted && personalDetailsForm.controls['BeforeMarriageFullName'].invalid" class="text-danger">
          <small>{{ getTranslation('validation.beforeMarriageFullNameRequired') }}</small>
        </div>
      </div>

      <!-- <div class="form-group col-12 col-md-4 mb-3" *ngIf="personalDetailsForm.get('GenderCode')?.value === 'O'">
        <label for="OtherGender">{{ getTranslation('form.specifyGender') }}</label>
        <input type="text" id="OtherGender" class="form-control" formControlName="Gender"
          [placeholder]="getTranslation('placeholder.enterGender')" maxlength="50" />
        <div *ngIf="submitted && personalDetailsForm.controls['Gender'].invalid" class="text-danger">
          <small>{{ getTranslation('validation.otherGenderRequired') }}</small>
        </div>
      </div> -->
    </div>

    <!-- Row 4: First Stay, Last Stay Date (conditional) -->
    <div class="row gx-2">
      <div class="form-group col-12 col-md-4 mb-3">
        <label class="form-label">{{ getTranslation('form.isFirstStayQuestion') }}: <span class="text-danger">*</span></label>
        <select class="form-control" id="inputFirstStay" formControlName="IsFirstStay">
          <option [ngValue]="null" disabled selected>{{ getTranslation('common.select') }}</option>
          <option [ngValue]="true">{{ getTranslation('common.yes') }}</option>
          <option [ngValue]="false">{{ getTranslation('common.no') }}</option>
        </select>
        <div *ngIf="submitted && personalDetailsForm.controls['IsFirstStay'].invalid" class="text-danger">
          {{ getTranslation('validation.requiredField') }}
        </div>
      </div>

      <div class="form-group col-12 col-md-4 mb-3" *ngIf="personalDetailsForm?.get('IsFirstStay')?.value === false">
        <label class="form-label">{{ getTranslation('form.lastStayQuestion') }}:<span class="text-danger">*</span></label>
        <app-custom-month-year-picker
          [formControl]="getLastStayDateControl()"
          [placeholder]="getTranslation('placeholder.lastStayMonthYear')"
          [maxDate]="maxDate"
        ></app-custom-month-year-picker>
        <div *ngIf="submitted && personalDetailsForm.controls['LastStayDate'].invalid" class="text-danger">
          {{ getTranslation('validation.lastStayDateRequired') }}
        </div>
      </div>
    </div>

    <!-- Commented out fields for reference -->
    <!-- <div class="form-group col-12 col-md-4 mb-3">
      <label for="inputOccupation" class="form-label">What is your current Occupation?: <span
          class="text-danger">*</span></label>
      <input type="text" class="form-control" id="inputOccupation" formControlName="Occupation"
        placeholder="Enter Occupation" maxlength="50">
      <div *ngIf="submitted && personalDetailsForm.controls['Occupation'].invalid" class="text-danger">
        This Field is required.
      </div>
    </div> -->

    <!-- <div class="form-group col-12 col-md-4 mb-3">
      <label for="inputPracticeYear" class="form-label">What year did you begin practicing Siddha Yoga?: <span class="text-danger">*</span></label>
      <input type="number" class="form-control" id="inputPracticeYear" formControlName="PracticeYear" placeholder="Enter Year" maxlength="50" >
      <div *ngIf="submitted && personalDetailsForm.controls['PracticeYear'].invalid" class="text-danger">
        This Field is required.
      </div>
    </div> -->

    <!-- <div class="form-group col-12 col-md-4 mb-3">
      <label for="inputPracticeYear" class="form-label">
        What year did you begin practicing Siddha Yoga?: <span class="text-danger">*</span>
      </label>

      <app-custome-year-picker
        [formControl]="getPracticeYearControl()"
        placeholder="Select Practice Year"
      ></app-custome-year-picker>

      
      <div *ngIf="submitted && personalDetailsForm.controls['PracticeYear'].invalid" class="text-danger">
        This field is required.
      </div>
    </div> -->

  </div>

  
  <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" 
       *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" 
            *ngIf="personalDetailsForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
  <!-- Buttons ends -->
</form>